/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CouponPay } from './CouponPay';
import {
    CouponPayFromJSON,
    CouponPayFromJSONTyped,
    CouponPayToJSON,
    CouponPayToJSONTyped,
} from './CouponPay';

/**
 * 
 * @export
 * @interface BillPaymentInfoVo
 */
export interface BillPaymentInfoVo {
    /**
     * 支付记录ID
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    id?: number;
    /**
     * 支付单编号
     * @type {string}
     * @memberof BillPaymentInfoVo
     */
    paymentCode?: string;
    /**
     * 结算方式：1-储蓄卡，2-信用卡，3-预存款支付
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    payType?: number;
    /**
     * 积分支付，不用积分支付的时候，值为0
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    pointsPay?: number;
    /**
     * 优惠券支付信息
     * @type {Array<CouponPay>}
     * @memberof BillPaymentInfoVo
     */
    couponPays?: Array<CouponPay>;
    /**
     * 实际支付金额
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    actualPayAmount?: number;
    /**
     * 卡支付金额
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    cardPay?: number;
    /**
     * 钱包支付金额
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    walletPay?: number;
    /**
     * 赠送金支付金额
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    bonusPay?: number;
    /**
     * 申请日期
     * @type {string}
     * @memberof BillPaymentInfoVo
     */
    applyDate?: string;
    /**
     * 是否删除：0-未删除，1-已删除
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    deleteStatus?: number;
    /**
     * 支付单类型：1-父支付单（合单），2-子支付单/正常单
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    paymentType?: number;
    /**
     * 父支付单ID（子支付单时有值，指向父支付单记录ID）
     * @type {number}
     * @memberof BillPaymentInfoVo
     */
    parentPaymentId?: number;
}

/**
 * Check if a given object implements the BillPaymentInfoVo interface.
 */
export function instanceOfBillPaymentInfoVo(value: object): value is BillPaymentInfoVo {
    return true;
}

export function BillPaymentInfoVoFromJSON(json: any): BillPaymentInfoVo {
    return BillPaymentInfoVoFromJSONTyped(json, false);
}

export function BillPaymentInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillPaymentInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'paymentCode': json['paymentCode'] == null ? undefined : json['paymentCode'],
        'payType': json['payType'] == null ? undefined : json['payType'],
        'pointsPay': json['pointsPay'] == null ? undefined : json['pointsPay'],
        'couponPays': json['couponPays'] == null ? undefined : ((json['couponPays'] as Array<any>).map(CouponPayFromJSON)),
        'actualPayAmount': json['actualPayAmount'] == null ? undefined : json['actualPayAmount'],
        'cardPay': json['cardPay'] == null ? undefined : json['cardPay'],
        'walletPay': json['walletPay'] == null ? undefined : json['walletPay'],
        'bonusPay': json['bonusPay'] == null ? undefined : json['bonusPay'],
        'applyDate': json['applyDate'] == null ? undefined : json['applyDate'],
        'deleteStatus': json['deleteStatus'] == null ? undefined : json['deleteStatus'],
        'paymentType': json['paymentType'] == null ? undefined : json['paymentType'],
        'parentPaymentId': json['parentPaymentId'] == null ? undefined : json['parentPaymentId'],
    };
}

export function BillPaymentInfoVoToJSON(json: any): BillPaymentInfoVo {
    return BillPaymentInfoVoToJSONTyped(json, false);
}

export function BillPaymentInfoVoToJSONTyped(value?: BillPaymentInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'paymentCode': value['paymentCode'],
        'payType': value['payType'],
        'pointsPay': value['pointsPay'],
        'couponPays': value['couponPays'] == null ? undefined : ((value['couponPays'] as Array<any>).map(CouponPayToJSON)),
        'actualPayAmount': value['actualPayAmount'],
        'cardPay': value['cardPay'],
        'walletPay': value['walletPay'],
        'bonusPay': value['bonusPay'],
        'applyDate': value['applyDate'],
        'deleteStatus': value['deleteStatus'],
        'paymentType': value['paymentType'],
        'parentPaymentId': value['parentPaymentId'],
    };
}

